import { ApiService } from '@/api';

export class FeedbackApi {
  private readonly baseUrl = '/api/feedback';

  public async postFeedback(feedback: { content: string }): Promise<void> {
    await ApiService.post(
      this.baseUrl,
      feedback,
    );
  }
}
